import * as _fs2 from "fs";

var _fs = "default" in _fs2 ? _fs2.default : _fs2;

import * as _path2 from "path";

var _path = "default" in _path2 ? _path2.default : _path2;

import * as _url2 from "url";

var _url = "default" in _url2 ? _url2.default : _url2;

import { dew as _loadConfigFileDew } from "./shared/loadConfigFile.js";
import { dew as _rollupDew } from "./shared/rollup.js";
import { dew as _mergeOptionsDew } from "./shared/mergeOptions.js";
import * as _process2 from "process";

var _process = "default" in _process2 ? _process2.default : _process2;

import * as _tty2 from "tty";

var _tty = "default" in _tty2 ? _tty2.default : _tty2;

import * as _perf_hooks2 from "perf_hooks";

var _perf_hooks = "default" in _perf_hooks2 ? _perf_hooks2.default : _perf_hooks2;

import * as _crypto2 from "crypto";

var _crypto = "default" in _crypto2 ? _crypto2.default : _crypto2;

import * as _events2 from "events";

var _events = "default" in _events2 ? _events2.default : _events2;

var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  _fs;
  _path;
  _url;

  const loadConfigFile_js = _loadConfigFileDew();

  _rollupDew();

  _mergeOptionsDew();

  _process;
  _tty;
  _perf_hooks;
  _crypto;
  _events;
  exports = loadConfigFile_js.loadAndParseConfigFile; //# sourceMappingURL=loadConfigFile.js.map

  return exports;
}